import React from 'react';
import { motion } from 'framer-motion';
export function AppScreenshots() {
  const screenshots = [{
    src: 'https://cdn.magicpatterns.com/uploads/1W1J6e82j7au2pvoFPkTsS/IMG_4140_2.png',
    alt: 'IntelliEats Home Screen with Scan Options',
    caption: 'Easy Scanning Options'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/os2N2XDcSvLjNDhdQRq49C/IMG_4142.png',
    alt: 'IntelliEats Scan Complete Summary',
    caption: 'Instant Analysis Summary'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6uZ6QUuqTgkVvEx3WusCKk/IMG_4145.png',
    alt: 'IntelliEats Detailed Ingredient Breakdown',
    caption: 'Detailed Ingredient Breakdown'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jNVxfYHiyM64oqXjAg6dEw/Promotional.png',
    alt: 'IntelliEats premium detection services showing nut, gluten, lactose, keto, vegetarian, and vegan diet settings',
    caption: 'Personalized Diet Settings'
  }];
  return <section className="py-20 bg-slate-900 overflow-hidden" data-id="element-80" data-mp="19trf2g32jms6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81" data-mp="19uavfsd2m343">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-82" data-mp="1erjhi41caram">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-83" data-mp="10stjmm6p4nl7">
            See The App in Action
          </h2>
          <p className="text-lg text-slate-400" data-id="element-84" data-mp="14tn8pivvk8fo">
            A clean, intuitive interface designed to give you answers in
            seconds. Take a look at the IntelliEats screenshots below.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-85" data-mp="vuibcfw1ul53">
          {screenshots.map((shot, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex flex-col items-center" data-id="element-86" data-mp="h6f3f0yg4zdn" data-mpi={idx}>
              <div className="rounded-[2rem] overflow-hidden border-4 border-slate-800 shadow-2xl mb-4" data-id="element-87" data-mp="2a1y382gkv058">
                <img src={shot.src} alt={shot.alt} className="w-full h-auto object-cover" data-id="element-88" data-mp="2523gmb3u4wpz" />
              </div>
              <p className="text-slate-300 font-medium text-sm text-center" data-id="element-89" data-mp="2xragbdf0zsct">
                {shot.caption}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}